import React, { useEffect, useRef, useState } from 'react'
import * as style from 'src/app/CardFeedDetails/components/CardFeedCardsTable.style'
import SvgMore from 'src/components/Svgs/SvgMore'

export interface CardActionsMenuProps {
  cardId: string
  translate: (str: string) => string
}

const CardActionsMenu: React.FC<CardActionsMenuProps> = ({
  cardId,
  translate,
}) => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!open) return undefined
    const handleClickOutside = (e: MouseEvent): void => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false)
      }
    }
    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return (): void => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [open])

  const menuId = `card-feed-card-actions-menu-${cardId}`

  return (
    <div ref={containerRef}>
      <button
        type="button"
        css={style.actionTrigger}
        data-testid="card-feed-card-actions"
        aria-label={translate('Row actions')}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={menuId}
        onClick={(): void => setOpen((prev) => !prev)}
      >
        <SvgMore width={18} height={18} viewBox="0 0 24 24" />
      </button>
      {open && (
        <div
          role="menu"
          id={menuId}
          css={style.actionMenu}
          data-testid="card-feed-card-actions-menu"
        >
          <button
            type="button"
            role="menuitem"
            css={style.actionMenuItem}
            onClick={(): void => setOpen(false)}
          >
            {translate('View Card')}
          </button>
        </div>
      )}
    </div>
  )
}

export default CardActionsMenu
